// extracted by mini-css-extract-plugin
export default {"tracker-comms":"tracker-comms-data_tracker-comms__7CfMe","sms":"tracker-comms-data_sms__XiZK8"};